import { render, staticRenderFns } from "./RelatoriosAtividadesPorColaborador.vue?vue&type=template&id=2867dc28"
import script from "./RelatoriosAtividadesPorColaborador.vue?vue&type=script&lang=js"
export * from "./RelatoriosAtividadesPorColaborador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports